import { get, post, put } from './masClient';
import GetOtpCounterRequest from '../types/GetOtpCounterRequest';
import GetOtpCounterResponse from '../types/GetOtpCounterResponse';
import ResetOtpCounterRequest from '../types/ResetOtpCounterRequest';
import errorHandler from './errorHandler';
import ReadCountryPrefixesResponse from 'types/ReadCountryPrefixesResponse';
import UpdateCountryPrefixRequest from 'types/UpdateCountryPrefixRequest';
import UpdateCountryPrefixResponse from 'types/UpdateCountryPrefixResponse';

export const getOtpCounter = async (
  request: GetOtpCounterRequest,
  accessToken: string,
): Promise<GetOtpCounterResponse> => post(`/v1/admin/otp-counter`, accessToken, request).catch(errorHandler);

export const resetOtpCounter = async (request: ResetOtpCounterRequest, accessToken: string): Promise<void> =>
  post(`/v1/admin/reset-otp-counter`, accessToken, request).catch(errorHandler);

export const readCountryPrefixes = async (accessToken: string): Promise<ReadCountryPrefixesResponse> =>
  get(`/v1/admin/otp/sms/prefixes`, accessToken).catch(errorHandler);

export const updateCountryPrefix = async (
  request: UpdateCountryPrefixRequest,
  accessToken: string,
): Promise<UpdateCountryPrefixResponse> => put(`/v1/admin/otp/sms/prefix`, accessToken, request).catch(errorHandler);
